if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          form: "form",
          inputId: "[name=id]",
          submitButton: '[name="add"]',
          errorWrapper: ".f-product-form__error-message-wrapper",
          customFields: ["[data-product-custom-field]"],
        };

        this.domNodes = queryDomNodes(this.selectors, this);

        this.form = this.domNodes.form;
        this.submitButton = this.domNodes.submitButton;
        this.domNodes.inputId.disabled = false;
        this.Notification = window.FoxTheme.Notification;
        this.notificationType = this.dataset.notificationType;
        this.customFields = document.querySelectorAll(
          this.selectors.customFields
        );
        this.cartDrawer = document.querySelector("cart-drawer");
        this.mainCart = document.querySelector("cart-items");
        this.type = this.dataset.type;

        this.variantIdInput = this.domNodes.inputId;

        this.errorWrapper =
          this.type === "product-card"
            ? this.closest(".product-card")
            : this.domNodes.errorWrapper;

        this.form &&
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      }

      validateForm(form) {
        const missingFields = [];
        if (!form) return missingFields;
        const fieldSelectors =
          '[data-product-custom-field] [name][required]:not([hidden]):not([type="hidden"])';
        const requiredFields = form.querySelectorAll(fieldSelectors);
        requiredFields.forEach((field) => {
          field.classList.remove("form-control--warning");
          if (field.type === "radio") {
            const buttons = form.querySelectorAll(
              `input[name="${field.name}"]`
            );
            const selected = Array.from(buttons).some((btn) => btn.checked);
            if (!selected) {
              missingFields.push(field);
              field.classList.add("form-control--warning");
            }
          } else if (!field.value) {
            missingFields.push(field);
            field.classList.add("form-control--warning");
          }
        });
        return missingFields;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const missing = this.validateForm(
          this.form.closest(".f-product-single__blocks")
        );

        if (missing && missing.length > 0) {
          return this.Notification.show({
            target: this.domNodes.errorWrapper,
            method: "appendChild",
            type: "warning",
            message: window.FoxThemeStrings.requiredField,
          });
        }

        if (this.submitButton.classList.contains("btn--loading")) return;

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("btn--loading");

        // バンドル商品の情報を取得
        const bundleItems = this.getBundleItems();
        
        // メイン商品とバンドル商品を一緒にカートに追加
        this.addToCartWithBundle(bundleItems);
      }

      /**
       * バンドル商品の情報を取得
       */
      getBundleItems() {
        const bundleItems = [];
        const checkboxes = document.querySelectorAll('.f-product__bundle-add-checkbox:checked');

        checkboxes.forEach(checkbox => {
          const productHandle = checkbox.dataset.bundleProductHandle;
          const variantSelect = document.getElementById(`bundle-variant-${productHandle}`);
          const quantityInput = document.getElementById(`bundle-quantity-${productHandle}`);

          if (variantSelect && variantSelect.value && quantityInput) {
            const quantity = parseInt(quantityInput.value) || 0;
            
            // 数量が0より大きい場合のみカートに追加
            if (quantity > 0) {
              bundleItems.push({
                id: variantSelect.value,
                quantity: quantity
              });
            }
          }
        });

        return bundleItems;
      }

      /**
       * メイン商品とバンドル商品を一緒にカートに追加
       */
      async addToCartWithBundle(bundleItems) {
        const formData = new FormData(this.form);
        const mainProductId = formData.get("id");
        const mainProductQuantity = formData.get("quantity") || 1;

        // カートに追加する商品リストを作成
        const items = [
          {
            id: mainProductId,
            quantity: parseInt(mainProductQuantity)
          },
          ...bundleItems
        ];

        // --- ここからバリアント入れ替えロジック ---
        // 1. カートの中身を取得
        let cart = null;
        try {
          const cartRes = await fetch('/cart.js');
          cart = await cartRes.json();
          console.log('[DEBUG] カート取得直後:', cart.items.map(i => ({handle: i.handle, variant_id: i.variant_id, title: i.title, quantity: i.quantity})));
        } catch (e) {
          console.error('カート情報の取得に失敗:', e);
        }

        // 2. ラッピング・熨斗、メッセージカードのバリアントを全て削除
        const forceSingleHandles = ['wrapping', 'message-card'];
        const itemsToRemove = {};
        if (cart && cart.items) {
          for (const item of cart.items) {
            if (forceSingleHandles.includes(item.handle)) {
              itemsToRemove[item.variant_id] = 0;
            }
          }
        }
        console.log('[DEBUG] 削除対象 itemsToRemove:', itemsToRemove);
        if (Object.keys(itemsToRemove).length > 0) {
          const removeRes = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
            body: JSON.stringify({ updates: itemsToRemove })
          });
          const removeJson = await removeRes.json();
          console.log('[DEBUG] 削除リクエスト後のレスポンス:', removeJson);
          await new Promise(resolve => setTimeout(resolve, 700));
          const afterRemoveRes = await fetch('/cart.js');
          const afterRemoveCart = await afterRemoveRes.json();
          console.log('[DEBUG] 削除後カート:', afterRemoveCart.items.map(i => ({handle: i.handle, variant_id: i.variant_id, title: i.title, quantity: i.quantity})));
        }
        // --- ここまで ---

        const config = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/javascript",
            "X-Requested-With": "XMLHttpRequest",
          },
        };

        let sectionToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:grouped-sections", {
            bubbles: true,
            detail: { sections: sectionToBundle },
          })
        );

        if (this.cartDrawer) {
          sectionToBundle = [
            ...sectionToBundle,
            ...this.cartDrawer
              .getSectionsToRender()
              .map((section) => section.id),
          ];
        }

        if (this.mainCart) {
          sectionToBundle = [
            ...sectionToBundle,
            ...this.mainCart
              .getSectionsToRender()
              .map((section) => section.section),
          ];
        }

        const body = JSON.stringify({
          items: items,
          sections: sectionToBundle,
          sections_url: window.location.pathname,
        });

        config.body = body;
        const { FoxThemeSettings, FoxThemeStrings } = window;
        
        fetch(`${FoxThemeSettings.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: mainProductId,
                errors: response.description,
                message: response.message,
              });

              // Dispatch event for third-party
              document.dispatchEvent(
                new CustomEvent("product-ajax:error", {
                  detail: {
                    errorMessage: response.description,
                  },
                })
              );

              this.error = true;
              return this.Notification.show({
                target:
                  this.notificationType === "toast"
                    ? document.body
                    : this.errorWrapper,
                method: "appendChild",
                type: "warning",
                message: response.description || response.message,
                last: 3000,
                sticky: this.notificationType === "toast",
              });
            }

            if (
              !FoxThemeSettings.cart.openDrawerWhenAdded ||
              FoxThemeSettings.cart.cartType === "page"
            ) {
              this.Notification.show({
                target: this.errorWrapper ? this.errorWrapper : document.body,
                method: "appendChild",
                type: "success",
                message: FoxThemeStrings.item_added,
                last: 3000,
                sticky: this.notificationType === "toast",
              });
            }
            if (FoxThemeSettings.cart.cartType === "page") {
              FoxThemeCartHelpers.getState().then((state) => {
                FoxThemeCartHelpers.updateCartCount(state.item_count);
              });
            }

            this.error = false;
            window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, response);

            // DispatchEvent for third-party
            document.dispatchEvent(
              new CustomEvent("product-ajax:added", {
                detail: {
                  product: response,
                },
              })
            );
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("btn--loading");
            this.submitButton.removeAttribute("aria-disabled");
          });
      }
    }
  );
}
